export default __webpack_public_path__ + "static/media/streamer_avatar3.91aa882a.png";